import React, { Component } from 'react';
import PropTypes from 'prop-types';

class UserTicketCreate extends Component {
    constructor(props) {
        super(props);

    }

    componentWillMount() {

    }
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

UserTicketCreate.propTypes = {

};

export default UserTicketCreate;